import * as React from 'react';

export function Icon({
  icon,
  className = '',
  ...otherProps
}: {
  icon: PrhIcon;
  className?: string;
}) {
  return <i {...otherProps} className={`icon icon-${icon} ${className}`} />;
}

/**
 * Available icons
 * Based on _fonts.scss
 */
export type PrhIcon =
  | 'home'
  | 'profile'
  | 'coin-pile'
  | 'happy-face'
  | 'cart'
  | 'game-controller'
  | 'trophy'
  | 'info-bubble'
  | 'life-preserver'
  | 'gear'
  | 'chat-bubble'
  | 'calendar'
  | 'envelope'
  | 'search'
  | 'logout'
  | 'location-pointer'
  | 'document-graph'
  | 'document-one'
  | 'document-two'
  | 'clock'
  | 'pencil'
  | 'printer'
  | 'gift'
  | 'eyeball'
  | 'trash-can'
  | 'at-mention'
  | 'chat-bubble-two'
  | 'thumbs-up'
  | 'alert'
  | 'heart'
  | 'headset'
  | 'star-empty'
  | 'star-half'
  | 'star-full'
  | 'add-circle'
  | 'x-circle'
  | 'check-circle'
  | 'paint-bucket'
  | 'align-justify-1-1'
  | 'remove'
  | 'power-off'
  | 'briefcase'
  | 'arrow-up'
  | 'arrow-right'
  | 'arrow-down'
  | 'arrow-left'
  | 'chevron-up'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'cell-phone'
  | 'info-bubble-filled'
  | 'documents'
  | 'happy-love'
  | 'document-heart'
  | 'instagram'
  | 'thumbs-up-filled'
  | 'twitter'
  | 'open-sign'
  | 'check'
  | 'check-square'
  | 'empty-square'
  | 'profile-gear'
  | 'profile-plus'
  | 'break-link'
  | 'profile-link'
  | 'plus'
  | 'share'
  | 'pinterest'
  | 'eyeball-closed'
  | 'links'
  | 'card-profile'
  | 'facebook'
  | 'google'
  | 'microsoft'
  | 'refresh'
  | 'camera'
  | 'bell';
